import React from 'react';
import { motion } from 'framer-motion';
import { XIcon, AlertTriangleIcon } from 'lucide-react';
export function ProblemSection() {
  return <section className="py-24 px-6 bg-navy-800 relative" data-id="element-152">
      <div className="max-w-5xl mx-auto" data-id="element-153">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-154">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-6 leading-tight" data-id="element-155">
            Simplifica Tu Vida con IA: <br className="hidden md:block" data-id="element-156" />
            <span className="text-cyan-neon" data-id="element-157">
              Domina ChatGPT y Recupera Horas Libres Cada Día
            </span>
          </h2>
          <p className="text-xl text-slate-300 max-w-3xl mx-auto font-medium" data-id="element-158">
            La guía práctica para resolver problemas, automatizar tareas y
            optimizar tu rutina en minutos
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-navy-900/50 border border-cyan-neon/10 rounded-2xl p-8 md:p-10 mb-16 text-center shadow-lg" data-id="element-159">
          <p className="text-lg md:text-xl text-slate-200 leading-relaxed" data-id="element-160">
            Imagina poder resolver tus pendientes diarios en minutos, sin estrés
            ni pérdida de tiempo. Ahora, con solo unos prompts precisos, puedes
            automatizar tus tareas, lograr orden y recuperar horas libres para
            lo que realmente importa.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-161">
          {/* Problem Card */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-navy-900/80 border border-red-500/20 rounded-2xl p-8 relative overflow-hidden" data-id="element-162">
            <div className="absolute top-0 right-0 w-32 h-32 bg-red-500/5 blur-[60px] rounded-full" data-id="element-163"></div>
            <div className="flex items-center gap-3 mb-6" data-id="element-164">
              <div className="bg-red-500/10 p-2 rounded-lg" data-id="element-165">
                <XIcon className="w-6 h-6 text-red-500" data-id="element-166" />
              </div>
              <h3 className="text-xl font-bold text-red-400" data-id="element-167">
                El Problema Real
              </h3>
            </div>
            <p className="text-slate-400 mb-6 font-medium" data-id="element-168">
              Cada día te enfrentas a un sinfín de tareas:
            </p>
            <ul className="space-y-4" data-id="element-169">
              {['Organizar tu agenda te consume tiempo.', 'Redactar correos profesionales se vuelve pesado.', 'Generar contenido creativo es un reto constante.', 'Y al final del día, sientes que no avanzas lo suficiente.'].map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-170">
                  <span className="text-red-500 mt-1" data-id="element-171">→</span>
                  <span className="text-slate-300" data-id="element-172">{item}</span>
                </li>)}
            </ul>
          </motion.div>

          {/* Failed Solutions Card */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-navy-900/80 border border-gold/20 rounded-2xl p-8 relative overflow-hidden" data-id="element-173">
            <div className="absolute top-0 right-0 w-32 h-32 bg-gold/5 blur-[60px] rounded-full" data-id="element-174"></div>
            <div className="flex items-center gap-3 mb-6" data-id="element-175">
              <div className="bg-gold/10 p-2 rounded-lg" data-id="element-176">
                <AlertTriangleIcon className="w-6 h-6 text-gold" data-id="element-177" />
              </div>
              <h3 className="text-xl font-bold text-gold" data-id="element-178">
                Por qué falló lo anterior
              </h3>
            </div>
            <ul className="space-y-4 mt-12" data-id="element-179">
              {['Las agendas tradicionales no se adaptan a tu ritmo.', 'Las apps de productividad son genéricas y complejas.', 'Perder horas buscando ideas o redactando propuestas es agotador.', 'Cursos largos de organización tardan semanas en aplicarse.'].map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-180">
                  <span className="text-gold mt-1" data-id="element-181">–</span>
                  <span className="text-slate-300" data-id="element-182">{item}</span>
                </li>)}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}